import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CurrentProductService, ProductAttributesComponent } from '@spartacus/storefront';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'cx-product-technical-documents',
    templateUrl: './sloan-product-technical-documents.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SloanProductTechnicalDocumentsComponent extends ProductAttributesComponent {
  technicalDocumentsList$: Observable<any[]> = this.product$.pipe(map((p: any) => this.extractTechnicalDocuments(p)));

  constructor(protected currentProductService: CurrentProductService) {
    super(currentProductService);
  }

  protected extractTechnicalDocuments(product: any): Observable<any>[] {
    if (!product.classifications || product.classifications.length < 1) {
      return [];
    }

    const mergedAndFilteredList = _.filter(
      _.flatMap(product.classifications, 'features'),
      (obj) =>
        _.includes(obj.code, 'architecturalworksheet_a') ||
        _.includes(obj.code, 'bimmodel_a') ||
        _.includes(obj.code, 'brochure') ||
        _.includes(obj.code, 'caddrawing_a') ||
        _.includes(obj.code, 'identificationguide') ||
        _.includes(obj.code, 'informationsheet_a') ||
        _.includes(obj.code, 'installationinstructions') ||
        _.includes(obj.code, 'pricingsheet') ||
        _.includes(obj.code, 'repairandmaintenanceguides_a') ||
        _.includes(obj.code, 'sdssafetydatasheet') ||
        _.includes(obj.code, 'sellsheet_a') ||
        _.includes(obj.code, 'troubleshootingguide_a') ||
        _.includes(obj.code, 'productguide_a') ||
        _.includes(obj.code, 'transparencyreport') ||
        _.includes(obj.code, 'maintenanceschedule_a') ||
        _.includes(obj.code, 'roughin_a') ||
        _.includes(obj.code, 'linedrawing') ||
        _.includes(obj.code, 'roughin_a') ||
        _.includes(obj.code, 'videos') ||
        _.includes(obj.code, 'specsheet') ||
        _.includes(obj.code, 'genericspec')
    );

    return _.sortBy(mergedAndFilteredList, ['name']);
  }
  ngOnInit() {
    this.technicalDocumentClickEvent();
  }
  technicalDocumentClickEvent() {
    document.addEventListener('click', function (event) {
      const ga = (window as any).ga;
      const tracker = ga?.getAll()[0];
      tracker?.set('page', event);
      tracker?.send('event');
    });
  }
}
